module.exports = __webpack_public_path__ + "static/amrit-series-logo-f096ef3b12ce9f7ecc97c32ec8e644e2.png";